import axios from "axios";
import store from "@/store";
import router from "@/router";
import {isEmpty} from "@/util/Helpers";
import moment from "moment/moment";

const baseDomain = `${!isEmpty(process.env.VUE_APP_BASE_URL) ? process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_SUB_DOMAIN : process.env.VUE_APP_BASE_SUB_DOMAIN}`;
/*
 * https://blog.clairvoyantsoft.com/intercepting-requests-responses-using-axios-df498b6cab62.
 */
// Step-1: Create a new Axios instance with a custom config.
// The timeout is set to 10s. If the request takes longer than
// that then the request will be aborted.
const AxiosClient = axios.create({
    baseURL: !isEmpty(process.env.VUE_APP_BASE_URL) ? baseDomain + '/resources' : '/' + baseDomain + '/resources',
    timeout: 80000000,
    // headers: {
    //     "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    //     "X-Requested-With": "XMLHttpRequest"
    // },
    withCredentials: true
});
//"Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",   "Content-Type": "application/json",
// Step-2: Create request, response & error handlers
const requestHandler = async (request) => {
    request.url = request.url + (request.url.includes('?') ? '&' : '?') + `__csc=${store.getters['auth/getCsCookies']}&_=${moment().valueOf()}`
    return request;
};

const responseHandler = async (response) => {
    return response;
};

const errorHandler = async (error) => {
    if (error.response.status == 439) {
        await store.dispatch("logout")
        if (router.currentRoute.fullPath !== '/auth/login') {
            await router.push("/auth/login");
        }
    }
    return error.response
};

// Step-3: Configure/make use of request & response interceptors from Axios
// Note: You can create one method say configureInterceptors, add below in that,
// export and call it in an init function of the application/page.
AxiosClient.interceptors.request.use(
    (request) => requestHandler(request),
    (error) => errorHandler(error)
);

AxiosClient.interceptors.response.use(
    (response) => responseHandler(response),
    (error) => errorHandler(error)
);

// Step-4: Export the newly created Axios instance to be used in different locations.
export default AxiosClient;